import React, { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Select, { SelectProps } from './Select'

type FormSelectProps = { name: string } & SelectProps

const FormSelect: FC<FormSelectProps> = (props) => {
  const formMethods = useFormContext()
  const { name, onChange, children, options } = props

  let hasErrors = formMethods.formState.errors[name] ? true : false
  let errorMessage = formMethods.formState.errors[name]?.message

  return (
    <Controller
      name={name}
      control={formMethods.control}
      render={({ field }) => (
        <Select
          {...field}
          {...props}
          onChange={(e) => {
            field.onChange(e)
            onChange && onChange(e)
          }}
          options={options}
          error={hasErrors}
          helperText={errorMessage}
        >
          {children}
        </Select>
      )}
    />
  )
}

export default FormSelect
